<!-- Breadcrumb -->
<ol class="breadcrumb">
  <li class="breadcrumb-item">
    <a routerLink="">Home</a>
  </li>
  <li class="breadcrumb-item active">
    Cadastro
  </li>
</ol>
<!-- //.Breadcrumb -->

<!--inicio form-->
<form autocomplete="off" [formGroup]="dadosAdicionaisForm" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <strong>Complemente seu cadastro (endereço e contatos)</strong>
        </div>
       <!--inicio - Erros-->
       <br/>

        <div class="row" *ngIf="msgErro">
          <div class="col-sm-12">
            <div class="alert alert-danger breakline" role="alert">{{msgErro}}</div>
          </div>
        </div>

        <!--Fim - Erros-->
        <div class="card-body">
          <div class="row">

            <div class="col-sm-12">

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="nome">Nome
                      <small>*</small>
                    </label>
                    <input AlphaOnly="true"
                        class="form-control"
                        name="nome"
                        id="nome"
                        formControlName="nome"
                        maxlength="80"
                        type="text"
                        autocomplete="off"
                        onpaste="return false;"
                        disabled>

                    <div *ngFor="let error of formErrors.nome" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="cep">CEP
                      <small>*</small>
                    </label>
                    <div class="input-group">
                      <input type="text" autocomplete="off" class="form-control"
                        name="cep" id="cep"
                        formControlName="cep"
                        (blur)="onBuscaCEP()"
                        (input)="changeCEP($event.target.value)"
                        [textMask]="maskCEP">
                        <span class="input-group-btn">
                          <button class="btn btn-secondary" type="button" (click)="onModalBuscaCEP()" title="Consultar CEP" data-toggle="tooltip" data-placement="top"
                            title="Consultar CEP">
                            <i class="fa fa-search"></i>
                          </button>
                        </span>
                    </div>

                    <div *ngFor="let error of formErrors.cep" class="alert alert-danger">
                      {{ error }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="form-group">
                    <label for="cidade">Município
                      <small>*</small>
                    </label>
                    <input type="text" autocomplete="off" class="form-control"
                    name="cidade"
                    id="cidade"
                    formControlName="cidade"
                    (input)="changeCidade($event.target.value)"
                    readonly>

                    <div *ngFor="let error of formErrors.cidade" class="alert alert-danger">
                      {{ error }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="sigUnidFederacao">UF
                      <small>*</small>
                    </label>
                    <input type="text" autocomplete="off" class="form-control"
                      name="sigUnidFederacao"
                      id="sigUnidFederacao"
                      formControlName="sigUnidFederacao"
                      (input)="changeUF($event.target.value)"
                      readonly>

                    <div *ngFor="let error of formErrors.sigUnidFederacao" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>
              </div>


              <div class="row">

                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="logradouro">Endereço
                      <small>*</small>
                    </label>
                    <input type="text" autocomplete="off" class="form-control"
                    name="logradouro"
                    id="logradouro"
                    formControlName="logradouro"
                    (input)="changeLogradouro($event.target.value)"
                    maxlength="60">

                    <div *ngFor="let error of formErrors.logradouro" class="alert alert-danger">
                      {{ error }}
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="numeroEndereco">Número<small>*</small> (Ex.: S/Nº, 10, 20B)</label>
                    <input type="text"
                        class="form-control"
                        name="numeroEndereco"
                        id="numeroEndereco"
                        formControlName="numeroEndereco"
                        (input)="changeNumeroEndereco($event.target.value)"
                        maxlength="10">

                        <div *ngFor="let error of formErrors.numeroEndereco" class="alert alert-danger">
                          {{ error }}
                        </div>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="bairro">Bairro</label>
                    <input type="text" autocomplete="off" class="form-control"
                    name="bairro"
                    id="bairro"
                    formControlName="bairro"
                    (input)="changeBairro($event.target.value)"
                    maxlength="40">
                  </div>
                </div>
                <div class="col-sm-6">
                  <label for="complementoEndereco">Complemento (Ex.: casa, bloco, apartamento)</label>
                  <input type="text" autocomplete="off"
                    class="form-control"
                    name="complementoEndereco"
                    (input)="changeComplementoEndereco($event.target.value)"
                    id="complementoEndereco"
                    formControlName="complementoEndereco"
                    maxlength="50">
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="dddTelefone">DDD
                          <small>*</small>
                        </label>
                        <input type="text" autocomplete="off"
                        class="form-control"
                        name="dddTelefone"
                        (input)="changeDddTelefone($event.target.value)"
                        id="dddTelefone"
                        formControlName="dddTelefone"
                        [textMask]="maskDDD">
                      </div>
                    </div>
                    <div class="col-sm-9">
                      <label for="telefone">Tel. Contato
                        <small>*</small>
                      </label>
                      <div class="form-group">
                        <input type="text" autocomplete="off"
                        class="form-control"
                        name="telefone"
                        (input)="changeTelefone($event.target.value)"
                        id="telefone"
                        formControlName="telefone"
                        maxlength="10">

                        <div *ngFor="let error of formErrors['telefone']" class="alert alert-danger">
                          {{ error }}
                        </div>
                        <div *ngFor="let error of formErrors['dddTelefone']" class="alert alert-danger">
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="dddCelular">DDD</label>
                        <input type="text" 
                        autocomplete="off" 
                        class="form-control" 
                        name="dddCelular" 
                        id="dddCelular" 
                        formControlName="dddCelular" 
                        [textMask]="maskDDD"
                        (input)="changeDddCelular($event.target.value)">
                      </div>
                    </div>
                    <div class="col-sm-9">
                      <label for="celular">Tel. Opcional</label>
                      <input type="text" autocomplete="off" 
                      class="form-control" 
                      name="celular" 
                      id="celular" 
                      formControlName="celular" 
                      (input)="changeCelular($event.target.value)"
                      maxlength="10">

                      <div *ngFor="let error of formErrors['celular']" class="alert alert-danger">
                        {{ error }}
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row" formGroupName="emailGroup">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="emailPrincipal">E-mail Principal
                      <small>*</small>
                    </label>
                    <input type="text" autocomplete="off" class="form-control"
                    name="emailPrincipal"
                    id="emailPrincipal"
                    (input)="changeEmailPrincipal($event.target.value)"
                    formControlName="emailPrincipal"
                    maxlength="60">

                    <div *ngFor="let error of formErrors['emailGroup.emailPrincipal']" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="confirmEmailPrincipal">Confirmar E-mail Principal
                      <small>*</small>
                    </label>
                    <input type="text" autocomplete="off" class="form-control"
                    name="confirmEmailPrincipal"
                    id="confirmEmailPrincipal"
                    formControlName="confirmEmailPrincipal"
                    (input)="changeEmailPrincipal($event.target.value)"
                      maxlength="60"
                      (paste)="$event.preventDefault()">

                    <div *ngFor="let error of formErrors['emailGroup.confirmEmailPrincipal']" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>

                <div class="col-sm-12" *ngIf="formErrors['emailGroup'].length > 0">
                  <div *ngFor="let error of formErrors['emailGroup']" class="alert alert-danger">
                    {{ error }}
                  </div>
                </div>


              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="emailOpcional">E-mail Opcional</label>
                    <input type="text" autocomplete="off" class="form-control" name="emailOpcional" id="emailOpcional" formControlName="emailOpcional" maxlength="60">
                  </div>
                </div>

              </div>
              <div *ngFor="let error of formErrors['emailOpcional']" class="alert alert-danger">
                {{ error }}
              </div>
              <div class="row" formGroupName="senhaGroup">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="senha">Senha
                      <small>*</small>
                    </label>
                    <input type="password" 
                    autocomplete="new-password" 
                    class="form-control" 
                    name="senha" 
                    id="senha" 
                    formControlName="senha">

                    <div *ngFor="let error of formErrors['senhaGroup.senha']" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="senhaConfirm">Confirmar Senha
                      <small>*</small>
                    </label>
                    <input type="password" 
                    autocomplete="new-password" 
                    class="form-control" 
                    name="senhaConfirm" 
                    id="senhaConfirm" 
                    formControlName="senhaConfirm"
                    (paste)="$event.preventDefault()">

                    <div *ngFor="let error of formErrors['senhaGroup.senhaConfirm']" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>

                <div class="col-sm-12" *ngIf="formErrors['senhaGroup'].length > 0">
                  <div *ngFor="let error of formErrors['senhaGroup']" class="alert alert-danger">
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="fraseSeguranca">Frase de Segurança
                      <small>*</small>
                    </label>
                    <input type="text" autocomplete="off" class="form-control" name="fraseSeguranca" id="fraseSeguranca" formControlName="fraseSeguranca" maxlength="100">
                  </div>

                  <div *ngFor="let error of formErrors.fraseSeguranca" class="alert alert-danger">
                    {{ error }}
                  </div>

                </div>

              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input class="form-check-input form-check-input-lg" type="checkbox" id="stsAceitaTermos" name="stsAceitaTermos" formControlName="stsAceitaTermos"> Li e concordo com as condições estabelecidas no regulamento da campanha NPB.
                    </label>
                    <a href="http://mbusca.sefaz.ba.gov.br/DITRI/normas_complementares/decretos/decreto_2017_18071.pdf#search=%2218071%22" target="_blank" rel="noopener">clique aqui</a>
                    <hr>
                  </div>
                </div>

                  <div class="col-sm-12">
                    <div class="row">
                        <div class="col-sm-6">
                            <label for="cmbAceitaTermoLGPD">Concorda em aderir ao Termo de Consentimento para tratamento de Dados Pessoais para a Campanha Nota Premiada Bahia?</label>
                            <a href="{{linkTermoLGPD}}" target="_blank" rel="noopener">Ler Termos LGPD</a>
                        </div>
                        <div class="col-sm-3">
                          <select name="cmbAceitaTermoLGPD"
                              id="cmbAceitaTermoLGPD"
                              class="form-control"
                              formControlName="cmbAceitaTermoLGPD"
                              (change)='onCmbAceitaTermoLGPDChange($event)'>
                            <option value="" selected>-- Selecione --</option>
                            <option value="1" selected>Sim</option>
                            <option value="0" selected>Não</option>
                          </select>
                          <div *ngFor="let error of formErrors.cmbAceitaTermoLGPD" class="alert alert-danger">
                            {{ error }}
                          </div>
                        </div>

                        <div *ngIf="mostrarAlertaParticipacao" class="alert alert-warning">
                          O cadastro só será realizado se o Termo de Consentimento de Proteção de Dados for aceito.
                          </div>
                      </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr>


  <div class="row" *ngIf="showRepresentanteLegal">
    <div class="col-sm-12">

    <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <strong>Representante Legal</strong>
        </div>

       <br/>

        <div class="row" *ngIf="msgErroRepresentanteLegal">
          <div class="col-sm-12">
            <div class="alert alert-danger breakline" role="alert">{{msgErroRepresentanteLegal}}</div>
          </div>
        </div>

        <div class="card-body">
         <div class="row">
            <div class="col-sm-12">

              <div class="row">

                <div class="col-sm-4">
                  <div class="form-group">
                        <label for="cpfRepresentanteLegal">CPF
                          <small>*</small>
                        </label>

                        <input type="text"
                              class="form-control"
                              name="cpfRepresentanteLegal"
                              id="cpfRepresentanteLegal"
                              placeholder="Digite o CPF do Representante Legal"
                              formControlName="cpfRepresentanteLegal"
                              [textMask]="maskCPF"
                              (keyup)="LimparErros($event)">

                         <div *ngFor="let error of formErrors.cpfRepresentanteLegal" class="alert alert-danger">
                          {{ error }}
                        </div>
                  </div>
                 </div>

                 <div class="col-sm-4">

                  <div class="form-group">
                    <label for="dataNascimentoRepresentanteLegal">Data de Nascimento *</label>

                          <input class="form-control"
                                id="dataNascimentoRepresentanteLegal"
                                name="dataNascimentoRepresentanteLegal"
                                placeholder="dd/mm/aaaa"
                                formControlName="dataNascimentoRepresentanteLegal"
                                [textMask]="maskData" 
                                (keyup)="LimparErros($event)">

                    <div *ngFor="let error of formErrors.dataNascimentoRepresentanteLegal" class="alert alert-danger">
                      {{ error }}
                    </div>
                  </div>
                </div>

                <div class="col-sm-8">
                   <div class="form-group">

                    <label for="nomeMaeRepresentanteLegal">Nome da Mãe do Representante Legal
                      <small>*</small>
                    </label>

                    <input AlphaOnly="true"
                        class="form-control"
                        name="nomeMaeRepresentanteLegal"
                        id="nomeMaeRepresentanteLegal"
                        placeholder="Digite o Nome da Mãe do Representante Legal"
                        formControlName="nomeMaeRepresentanteLegal"
                        maxlength="80"
                        type="text"
                        autocomplete="off"
                        (keyup)="LimparErros($event)"
                        onpaste="return false;">

                    <div *ngFor="let error of formErrors.nomeMaeRepresentanteLegal" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>

              </div>

              <hr>
              <div class="row">
                <div class="col-sm-8">
                  <div class="form-group">

                   <label for="nomeRepresentanteLegal">Nome
                     <small>*</small>
                   </label>

                   <input AlphaOnly="true"
                       class="form-control"
                       name="nomeRepresentanteLegal"
                       id="nomeRepresentanteLegal"
                       formControlName="nomeRepresentanteLegal"
                       maxlength="80"
                       type="text"
                       autocomplete="off"
                       onpaste="return false;">

                   <div *ngFor="let error of formErrors.nomeRepresentanteLegal" class="alert alert-danger">
                     {{ error }}
                   </div>

                 </div>
               </div>

               <div class="col-sm-4">
                <div class="form-group">

                  <label for="tipoResponsabilidadeRepresentanteLegal">Tipo Responsabilidade *</label>

                  <select name="tipoResponsabilidadeRepresentanteLegal"
                          id="tipoResponsabilidadeRepresentanteLegal"
                          class="form-control"
                          formControlName="tipoResponsabilidadeRepresentanteLegal"
                          (change)="ontipoResponsabilidadeRepresentanteLegalChange()">

                      <option value="" selected>-- Selecione --</option>
                      <option *ngFor='let tipoResponsabilidadeRepresentanteLegal of tiposResponsabilidadesRepresentanteLegal; let i = index;'
                              [value]="tipoResponsabilidadeRepresentanteLegal.codTipoResponsabilidadeRepresentanteLegal">
                        {{ tipoResponsabilidadeRepresentanteLegal.descTipoResponsabilidadeRepresentanteLegal }}
                      </option>

                  </select>

                  <div *ngFor="let error of formErrors.tipoResponsabilidadeRepresentanteLegal" class="alert alert-danger">
                    {{ error }}
                  </div>

                </div>
              </div>
              </div>

              <div class="col-sm-12">
                <div class="form-check">
                  <label class="form-check-label">

                    <input class="form-check-input form-check-input-lg" type="checkbox"
                      name="stsUtilizarMesmoEndereco"
                      id="stsUtilizarMesmoEndereco"
                      [(ngModel)]="isChecked"
                      (change)="checkUtilizarMesmoEndereco(isChecked?'S':'N')"
                      formControlName="stsUtilizarMesmoEndereco" checked/>
                      Mesmo Endereço do Cidadão.
                  </label>
                </div>
              </div>

              <div class="row">

                <div class="col-sm-4">

                  <div class="form-group">

                    <label for="cepRepresentanteLegal">CEP
                      <small>*</small>
                    </label>

                    <div class="input-group">

                      <input type="text" autocomplete="off" class="form-control"
                      name="cepRepresentanteLegal"
                      id="cepRepresentanteLegal"
                      formControlName="cepRepresentanteLegal"
                      (blur)="onBuscaCEPRepresentanteLegal()"
                      (input)="onBuscaCEPRepresentanteLegal()"
                      [textMask]="maskCEP">

                      <span class="input-group-btn">
                        <button class="btn btn-secondary" type="button" 
                        (click)="onModalBuscaCEPRepresentanteLegal()" 
                        title="Consultar CEP" data-toggle="tooltip" data-placement="top"
                          title="Consultar CEP">
                          <i class="fa fa-search"></i>
                        </button>
                      </span>
                    </div>

                    <div *ngFor="let error of formErrors.cep" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>

                <div class="col-sm-5">
                  <div class="form-group">
                    <label for="cidadeRepresentanteLegal">Município
                      <small>*</small>
                    </label>
                    <input type="text" autocomplete="off" class="form-control" name="cidadeRepresentanteLegal" id="cidadeRepresentanteLegal" formControlName="cidadeRepresentanteLegal" readonly>

                    <div *ngFor="let error of formErrors.cidadeRepresentanteLegal" class="alert alert-danger">
                      {{ error }}
                    </div>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="sigUnidFederacaoRepresentanteLegal">UF
                      <small>*</small>
                    </label>
                    <input type="text" autocomplete="off" class="form-control" name="sigUnidFederacaoRepresentanteLegal" id="sigUnidFederacaoRepresentanteLegal" formControlName="sigUnidFederacaoRepresentanteLegal"
                      readonly>

                    <div *ngFor="let error of formErrors.sigUnidFederacaoRepresentanteLegal" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>
              </div>

              <div class="row">

                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="logradouro">Endereço
                      <small>*</small>
                    </label>
                    <input type="text" autocomplete="off" class="form-control"
                      name="logradouroRepresentanteLegal"
                      id="logradouroRepresentanteLegal"
                      formControlName="logradouroRepresentanteLegal"
                      maxlength="60">

                    <div *ngFor="let error of formErrors.logradouro" class="alert alert-danger">
                      {{ error }}
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="numeroEnderecoRepresentanteLegal">Número<small>*</small> (Ex.: S/Nº, 10, 20B)</label>
                    <input type="text"
                        class="form-control"
                        name="numeroEnderecoRepresentanteLegal"
                        id="numeroEnderecoRepresentanteLegal"
                        formControlName="numeroEnderecoRepresentanteLegal"
                        maxlength="10">

                        <div *ngFor="let error of formErrors.numeroEnderecoRepresentanteLegal" class="alert alert-danger">
                          {{ error }}
                        </div>
                  </div>
                </div>

               </div>

             <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="bairroRepresentanteLegal">Bairro</label>
                    <input type="text" autocomplete="off" class="form-control"
                    name="bairroRepresentanteLegal" id="bairroRepresentanteLegal"
                    formControlName="bairroRepresentanteLegal"
                    maxlength="40">
                  </div>
                </div>
                 <div class="col-sm-6">
                  <label for="complementoEnderecoRepresentanteLegal">Complemento (Ex.: casa, bloco, apartamento)</label>
                  <input type="text" autocomplete="off"
                    class="form-control"
                    name="complementoEnderecoRepresentanteLegal"
                    id="complementoEnderecoRepresentanteLegal"
                    formControlName="complementoEnderecoRepresentanteLegal"
                    maxlength="50">
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-check">
                  <label class="form-check-label">

                    <input class="form-check-input form-check-input-lg" type="checkbox"
                      name="stsUtilizarMesmoTelefone"
                      id="stsUtilizarMesmoTelefone"
                      [(ngModel)]="isCheckedTelefone"
                      (change)="checkUtilizarMesmoTelefone(isCheckedTelefone?'S':'N')"
                      formControlName="stsUtilizarMesmoTelefone" checked/>
                      Mesmo Telefone do Cidadão.
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="dddTelefoneRepresentanteLegal">DDD
                          <small>*</small>
                        </label>
                        <input type="text" autocomplete="off" class="form-control"
                        name="dddTelefoneRepresentanteLegal" id="dddTelefoneRepresentanteLegal"
                        formControlName="dddTelefoneRepresentanteLegal" [textMask]="maskDDD">
                      </div>
                    </div>
                     <div class="col-sm-9">
                      <label for="telefoneRepresentanteLegal">Tel. Contato
                        <small>*</small>
                      </label>
                      <div class="form-group">
                          <input type="text" 
                          autocomplete="off" 
                          class="form-control"
                          name="telefoneRepresentanteLegal"
                          id="telefoneRepresentanteLegal"
                          formControlName="telefoneRepresentanteLegal"
                          maxlength="10">

                        <div *ngFor="let error of formErrors['telefoneRepresentanteLegal']" class="alert alert-danger">
                          {{ error }}
                        </div>
                        <div *ngFor="let error of formErrors['dddTelefoneRepresentanteLegal']" class="alert alert-danger">
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="dddCelularRepresentanteLegal">DDD</label>

                        <!-- -->
                         <input type="text" autocomplete="off"
                          class="form-control"
                          name="dddCelularRepresentanteLegal"
                          id="dddCelularRepresentanteLegal"
                          formControlName="dddCelularRepresentanteLegal"
                          [textMask]="maskDDD">
                      </div>
                    </div>
                    <div class="col-sm-9">
                      <label for="celularRepresentanteLegal">Tel. Opcional</label>

                      <!--  -->
                      <input type="text" autocomplete="off" class="form-control"
                        name="celularRepresentanteLegal"
                        id="celularRepresentanteLegal"
                        formControlName="celularRepresentanteLegal"
                        maxlength="10">

                      <div *ngFor="let error of formErrors['celularRepresentanteLegal']" class="alert alert-danger">
                        {{ error }}
                      </div>
                      <div *ngFor="let error of formErrors['dddCelularRepresentanteLegal']" class="alert alert-danger">
                        {{ error }}
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-sm-12">
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input form-check-input-lg" type="checkbox"
                      name="stsUtilizarMesmoEmail"
                      id="stsUtilizarMesmoEmail"
                      [(ngModel)]="isCheckedMesmoMail"
                      (change)="checkUtilizarMesmoEmail(isCheckedMesmoMail?'S':'N')"
                      formControlName="stsUtilizarMesmoEmail" checked/>
                      Mesmo E-Mail do Cidadão.
                  </label>
                </div>
              </div>

              <div class="row" formGroupName="emailGroupRepresentanteLegal">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="emailPrincipalRepresentanteLegal">E-mail
                      <small>*</small>
                    </label>
                    <input type="text" autocomplete="off" class="form-control" name="emailPrincipalRepresentanteLegal" id="emailPrincipalRepresentanteLegal" formControlName="emailPrincipalRepresentanteLegal" maxlength="60">

                    <div *ngFor="let error of formErrors['emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal']" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                     <label for="confirmEmailPrincipalRepresentanteLegal">Confirmar E-mail
                      <small>*</small>
                    </label>
                    <input type="text" 
                    autocomplete="off" 
                    class="form-control" 
                    name="confirmEmailPrincipalRepresentanteLegal" 
                    id="confirmEmailPrincipalRepresentanteLegal" 
                    formControlName="confirmEmailPrincipalRepresentanteLegal"
                    maxlength="60"
                    (paste)="$event.preventDefault()">

                    <div *ngFor="let error of formErrors['emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal']" class="alert alert-danger">
                      {{ error }}
                    </div>

                  </div>
                </div>

              </div>
              <div *ngFor="let error of formErrors['emailGroupRepresentanteLegal']" class="alert alert-danger">
                {{ error }}
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
    </div>
  </div>
  </div>

  <app-consumidor-instituicao [breadcrumbInstituicao]="false" (OnInstituicaoSelected)="instituicaoSelected($event)"></app-consumidor-instituicao>
  <hr>

  <div class="row">

    <div *ngFor="let error of formErrors.errosSelecao" class="alert alert-danger col-sm-12">
      {{ error }}
    </div>

    <div class="col-sm-12">

      <button type="submit" class="btn btn-success" data-toggle="tooltip" data-placement="top"
      title="Concluir Cadastro" >Concluir Cadastro</button>

      <button type="button" class="btn btn-danger" (click)="cancelaCadastro()" data-toggle="tooltip" data-placement="top" title="Cancelar o Cadastramento"
        [disabled]="btnCancelarDisabled">Cancelar o Cadastramento</button>

    </div>
  </div>
  <!--fim form-->
</form>



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-adicional/consumidor-adicional.component.html